// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerText":"Footer_footerText__rlW5Y","footerTextUpdate":"Footer_footerTextUpdate__1MC-c","footerPosition":"Footer_footerPosition__3g21P"};